<template>
	<CRow>
		<CCol col="12" xl="12">
			<CCard>
				<CCardHeader>
					<strong>کاربرهای گروه {{group_name}}</strong> 
				</CCardHeader>
				<CCardBody>
                    <CDataTable
                        hover
                        striped
                        columnFilter
                        :items="items"
                        :fields="fields"
                        :items-per-page="10"
                        :active-page="active_page"
                        :pagination="{ doubleArrows: false, align: 'center'}"
                        :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }"
                    >
                        <template #user_name="data">
                            <td>
                                <router-link :to="`/profile/${data.item.id}`">
                                    {{data.item.user_name}}
                                </router-link>
                            </td>
                        </template>
                            <template #is_active="data">
                            <td v-if="data.item.is_active">
                                <CIcon name="cilCheckAlt" size="lg"/>
                            </td>
                            <td v-else>
                                <CIcon name="cilX" size="lg"/>
                            </td>
                        </template>
                        <template #action="data">
                            <td>
                                <template>
                                <div class="flex-container">
                                    <div @click="delete_modal=true;id=data.item.id"
                                        v-c-tooltip.hover="'حذف'">
                                        <CIcon name="cilTrash" size="lg"/>
                                    </div>
                                </div>
                                </template>
                            </td>
                        </template>
                    </CDataTable>
			</CCardBody>
            <CCardFooter>
                <CButton v-show="$store.state.perms.can_add_user" color="primary"
                    @click="redirect_to(`/group/${$route.params.id}/user/add`)">افزودن کاربر</CButton>
            </CCardFooter>
		</CCard>
		</CCol>
		<CModal
			title="دقت کنید"
			size="sm"
			color="danger"
			:show.sync="delete_modal"
			>
			<p>آیا برای حذف شناسه {{id}} از گروه اطمینان دارید؟</p>
			<template #footer>
				<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
				<CButton @click="delete_row" color="danger">بله</CButton>
			</template>
		</CModal>
  </CRow>
</template>

<script>
export default {
	data() {
		return {
			items: [],
			fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'user_name', label: 'کاربر' },
                { key: 'is_active', label: 'وضعیت' },
                { key: 'action', label: 'عملیات' }
            ],
			delete_modal: false,
            id: 0,
            group_name: '',
            active_page: 1,
		}
	},
	mounted() {
		this.get();
	},
	methods: {
		get() {
            this.axios.get('user_groups/'
                + '?id=' + this.$route.params.id 
                + '&group_users=1')
                .then(res => {
                    this.group_name = res.data[0].name;
                    res.data[0].group_users.map(val => {
                        val.user_name = `${val.first_name} ${val.last_name}`;
                    });
                    this.items = res.data[0].group_users;
                })
		},
		delete_row() {
			this.axios.delete('user_groups/'
            + this.id
            + '/' 
            + this.$route.params.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
				});
				this.delete_modal = false;
                this.count();
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
				});
				this.delete_modal = false;
			})
        },
        redirect_to(route) {
            this.$router.push(route);
        },
	},
	beforeCreate(){
        if(this.$store.state.perms.can_view_user_group_page == false
            && this.$store.state.perms.can_view_user_info_page == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>